import { combineReducers } from 'redux';
import type { IGlAssignmentModalState } from './GlAssignmentModalSlice';
import { glAssignmentModalSlice } from './GlAssignmentModalSlice';
import type { IMetaProductPageState as IPageState } from './MetaProductPageSlice';
import { metaProductPageSlice } from './MetaProductPageSlice';

export interface IMetaProductPageState {
	page: IPageState;
	glAssignmentModal: IGlAssignmentModalState;
}

export const reducer = combineReducers<IMetaProductPageState>({
	page: metaProductPageSlice.reducer,
	glAssignmentModal: glAssignmentModalSlice.reducer,
});
